export const optionInstructionType = [
  {
    label: "General Instruction",
    value: "GENERAL_INSTRUCTION",
    type: "general",
  },
  {
    label: "Medicine Instruction",
    value: "MEDICINE_INSTRUCTION",
    type: "medicine",
  },
  {
    label: "Special Instruction",
    value: "SPECIAL_INSTRUCTION",
    type: "special",
  },
  {
    label: "Follow Up Instruction",
    value: "FOLLOW_UP_INSTRUCTION",
    type: "follow-up",
  },
  {
    label: "Alert Instruction",
    value: "ALERT_INSTRUCTION",
    type: "alert",
  },
  {
    label: "Diet Nutrition Instruction",
    value: "DIET_NUTRITION_INSTRUCTION",
    type: "diet-and-nutrition",
  },
  {
    label: "Investigation Instruction",
    value: "INVESTIGATION_INSTRUCTION",
    type: "investigation",
  },
  {
    label: "General Instruction Notes",
    value: "GENERAL_INSTRUCTION_NOTE",
    type: "general-instruction",
  },
];
